import React from 'react';
import { Box, Container } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import Header from './Header/HeaderContent/index';
import BottomNav from './Navigation/BottomNav';

import useConfig from 'hooks/useConfig';
import { AppPages } from 'types/Enums';

type RouteConfig = {
  path: `${AppPages}` | `${AppPages}/${string}`;
  title: string | ((params: Record<string, string>) => string);
};

const pageTitleMap: RouteConfig[] = [
  { path: AppPages.HOME, title: 'Home' },
  { path: AppPages.INBOX, title: 'Inbox' },
  { path: AppPages.SETTINGS, title: 'Settings' },
  { path: AppPages.SETTINGS_EDIT_PROFILE, title: 'Edit Profile' },
  { path: AppPages.SETTINGS_WALLET, title: 'Wallet' },
  { path: AppPages.SETTINGS_HISTORY, title: 'History' },
  { path: AppPages.SETTINGS_BLOCKED_LIST, title: 'Blocked List' },
  { path: AppPages.SETTINGS_ABOUT, title: 'About' },
  { path: AppPages.SETTINGS_PRIVACY_POLICY, title: 'Privacy Policy' },
  { path: AppPages.SETTINGS_TERM_OF_SERVICE, title: 'Terms of Service' },
  { path: AppPages.SETTINGS_HELP_AND_FEEDBACK, title: 'Help & Feedback' },
  { path: `${AppPages.PROFILE}/:id`, title: 'Profile' },
  { path: `${AppPages.SHARE}/:id`, title: 'Share' },
  { path: `${AppPages.SEND}/:id`, title: 'Send' },
  { path: AppPages.OUTBOX, title: 'Sent' }
];

const bottomNavPages: AppPages[] = [AppPages.HOME, AppPages.PROFILE, AppPages.INBOX, AppPages.SETTINGS, AppPages.OUTBOX, AppPages.SEARCH];

const FULL_BLEED_PAGES = ['/inbox', '/home', '/profile', '/outbox', '/search'];
const FULL_BLEED_PREFIXES = ['/share/', '/send/', '/settings'];

const MainLayout: React.FC = () => {
  const { container } = useConfig();
  const { pathname } = useLocation();
  const isFullBleed = FULL_BLEED_PAGES.includes(pathname) || FULL_BLEED_PREFIXES.some((p) => pathname.startsWith(p));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Header bottomNavPages={bottomNavPages} pageTitleMap={pageTitleMap} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mb: 10,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Container
          maxWidth={isFullBleed ? false : container ? 'xl' : false}
          sx={{
            px: { xs: 2, sm: 3 },
            pb: 2,
            flexGrow: 1
          }}
        >
          <motion.div
            key={window.location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25 }}
          >
            <Outlet />
          </motion.div>
        </Container>
      </Box>

      <BottomNav />
    </Box>
  );
};

export default MainLayout;
